import { TCol } from "../../../../../../components/layout/listing-table/listing-table.types";
import { Date } from "../../../../../../components/layout/listing-table/listing-table-render-components";

import { getFormattedFileSize } from "../../../../types/file-attachment.functions";
import { IAsset } from "../../../../types/file-attachment.interface";

import { renderFileLink } from "../components/file-link/file-link.functions";
import { renderFileActions } from "../components/file-actions/file-actions.functions";

import { IAssetsTableColumnsOptions } from "./file-upload-assets-table.interface";

export const getDefaultAssetTableColumns = (options: IAssetsTableColumnsOptions): TCol[] => [
  {
    label: "File",
    key: "",
    render: (row) => renderFileLink(row as IAsset, options.canDownload),
  },
  { label: "Size", key: "size", render: (row) => getFormattedFileSize(row as IAsset) },
  { label: "Upload Date", key: "createdAt", render: (row) => Date(row.createdAt) },
  { label: "Action", key: "", render: (row) => renderFileActions(row as IAsset, options) },
];
